import React, { Fragment, useState, useEffect } from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
const Loader = (props) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(false);
    }, 3000);

    return () => {
      clearTimeout(timeout);
    };
  }, [show]);

  return (
    <Fragment>
      <div className={`loader-wrapper ${show ? '' : 'loderhide'}`}>
        {/* <div className='loader-index'>
          <span></span>
        </div> */}
        {/* <svg>
          <defs></defs>
          <filter id='goo'>
            <fegaussianblur in='SourceGraphic' stdDeviation='11' result='blur'></fegaussianblur>
            <fecolormatrix in='blur' values='1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9' result='goo'></fecolormatrix>
          </filter>
        </svg> */}
        {/* <NewtonsCradleLoader /> */}
        <div style={{ width: '150px', height: '150px', margin: 'auto' }}>
          <DotLottieReact
            src="https://lottie.host/8a4cd622-caf4-4381-9162-fe75c98618ce/LOBpR5fIM0.lottie"
            loop
            autoplay
            speed={2}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default Loader;
